import type { Dependency } from '@univerjs/core';
import { Plugin, UniverInstanceType, touchDependencies, Inject, Injector } from '@univerjs/core';
import { ComponentButtonsController } from './components-menu.controller';
import { ErrorDisplayController } from './error-display.controller';

const COMPONENT_BUTTONS_PLUGIN = 'COMPONENT_BUTTONS_PLUGIN';
const ERROR_DISPLAY_PLUGIN = 'ERROR_DISPLAY_PLUGIN';

export class ComponentButtonsPlugin extends Plugin {
  static override type = UniverInstanceType.UNIVER_SHEET;
  static override pluginName = COMPONENT_BUTTONS_PLUGIN;

  constructor(@Inject(Injector) protected readonly _injector: Injector) {
    super();
  }

  override onStarting(): void {
    ([[ComponentButtonsController], [ErrorDisplayController]] as Dependency[]).forEach((d) => this._injector.add(d));
  }

  override onRendered(): void {
    touchDependencies(this._injector, [[ComponentButtonsController], [ErrorDisplayController]]);
  }
}

// Error suppression only (no component menu) — for the read-only RPK nav pane.
export class ErrorDisplayPlugin extends Plugin {
  static override type = UniverInstanceType.UNIVER_SHEET;
  static override pluginName = ERROR_DISPLAY_PLUGIN;

  constructor(@Inject(Injector) protected readonly _injector: Injector) {
    super();
  }

  override onStarting(): void {
    ([[ErrorDisplayController]] as Dependency[]).forEach((d) => this._injector.add(d));
  }

  override onRendered(): void {
    touchDependencies(this._injector, [[ErrorDisplayController]]);
  }
}
